/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService, AuthBaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { XFoundHttpClient } from '@/core/components/authentication/http/abstractions/xfound.httpclient';

import { PortalkonfigurationDisplayModel as AceXFoundPortalCoreCaqModelsPortalkonfigurationDisplayModel } from '../models/ace/xFound/Portal/Core/CAQ/Models/portalkonfiguration-display-model';
import { GetPortalkonfigurationQuery as AceXFoundPortalCoreCaqPortalkonfigurationQueriesGetPortalkonfigurationQuery } from '../models/ace/xFound/Portal/Core/CAQ/Portalkonfiguration/Queries/get-portalkonfiguration-query';

@Injectable({
providedIn: 'root',
})

export class PortalkonfigurationService extends BaseService {
constructor(
config: ApiConfiguration,
http: HttpClient,
authHttp: XFoundHttpClient
) {
super(config, http, authHttp);
}

  /**
   * Path part for operation apiPortalkonfigurationGet
   */
  static readonly ApiPortalkonfigurationGetPath = '/api/Portalkonfiguration';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPortalkonfigurationGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPortalkonfigurationGet$Plain$Response(params?: {
    query?: AceXFoundPortalCoreCaqPortalkonfigurationQueriesGetPortalkonfigurationQuery;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsPortalkonfigurationDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, PortalkonfigurationService.ApiPortalkonfigurationGetPath, 'get');
    if (params) {
      rb.query('query', params.query, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/plain',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsPortalkonfigurationDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPortalkonfigurationGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPortalkonfigurationGet$Plain(params?: {
    query?: AceXFoundPortalCoreCaqPortalkonfigurationQueriesGetPortalkonfigurationQuery;
  }): Observable<AceXFoundPortalCoreCaqModelsPortalkonfigurationDisplayModel> {

    return this.apiPortalkonfigurationGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsPortalkonfigurationDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsPortalkonfigurationDisplayModel)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPortalkonfigurationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPortalkonfigurationGet$Response(params?: {
    query?: AceXFoundPortalCoreCaqPortalkonfigurationQueriesGetPortalkonfigurationQuery;
  }): Observable<StrictHttpResponse<AceXFoundPortalCoreCaqModelsPortalkonfigurationDisplayModel>> {

    const rb = new RequestBuilder(this.rootUrl, PortalkonfigurationService.ApiPortalkonfigurationGetPath, 'get');
    if (params) {
      rb.query('query', params.query, {});
    }

    return this.authHttp.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      withCredentials: true,
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AceXFoundPortalCoreCaqModelsPortalkonfigurationDisplayModel>;
      })
    );
    
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPortalkonfigurationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPortalkonfigurationGet(params?: {
    query?: AceXFoundPortalCoreCaqPortalkonfigurationQueriesGetPortalkonfigurationQuery;
  }): Observable<AceXFoundPortalCoreCaqModelsPortalkonfigurationDisplayModel> {

    return this.apiPortalkonfigurationGet$Response(params).pipe(
      map((r: StrictHttpResponse<AceXFoundPortalCoreCaqModelsPortalkonfigurationDisplayModel>) => r.body as AceXFoundPortalCoreCaqModelsPortalkonfigurationDisplayModel)
    );
  }

}